import tripPlanService from '@/store/modules/trip-plan/service'
import resampleRoute from '@/tools/fuel-plan/resample-route'
import calculateInsertPointIndex from '@/tools/fuel-plan/insert-waypoints';
import api from '@/api/fuel-plan'

const Service = new tripPlanService()

export const fuelPlanSettings = {
  network: ['Truck Stops', 'TA', 'Petro', 'Loves', 'AMbest', 'Pilot', 'Flying J', 'KwikTrip/KwikStar', 'Fuel'],
  startTank: '80',
  tankCapacity: '200',
  mpg: '7',
  gallons: '20'
}

export function calculateRoute(settingList, truckInfo, tripPlanPoints, userId, cancelToken) {
  return Service.calculateRoute(
    { settingList, truckInfo, tripPlanPoints },
    { alternatives: 1 },
    userId,
    cancelToken
  )
}

export function calcFuelPlan(route, cancelToken) {
  if (!route) return null
  let params = {
    startFuel: Number(fuelPlanSettings.startTank),
    milesPerGallon: Number(fuelPlanSettings.mpg),
    tankCapacity: Number(fuelPlanSettings.tankCapacity),
    minFuelCapacity: Number(fuelPlanSettings.gallons),
    fuelChains: fuelPlanSettings.network,
    tripId: "01616809138974",
    fuelPlanId: "016168091389741616810434102",
    pointDistances: resampleRoute(route.shape)
  }
  return api.getFuelPlan(params, cancelToken).then(({ res }) => {
    let info = {}
    if (res.data.code === 500) {
      let message = res.data.message
      if (message.indexOf('Cannot reach first poi') !== -1) {
        message = 'Cannot reach first poi'
      }
      info = {
        routeType: 'fuelSuccessful',
        fuelPlanResult: {
          message,
          code: 500
        }
      }
    } else {
      const fuelPlan = res.data.data
      fuelPlan.poi_list = fuelPlan.poi_list.filter( x => x.lat !== 0)
      fuelPlan.poi_list.forEach(x => {
        x.mappedPosition = {latitude: x.lat, longitude: x.lng}
        x.stopPointType = 'fuelStation'
        x.pointType = 'fuelStation'
        x.pointId = x.ident
        x.poiId = x.ident
        // 再次规划路线使用
        x.latitude = x.lat
        x.longitude = x.lng
        x.value = x.title
        x.id = `${x.lat}-${x.lng}`
        x.uniqueIdentifier = `${x.ident}-${x.lat}-${x.lng}-${Date.now()}`
        x.stopType = 'Fuel'
        x.pointInfo = {...x}
      })
      let fuelPlanRoute = { ...route, fuelPlanResult: fuelPlan }
      let waypoints = fuelPlanRoute.waypointList.map(item => {
        item = Object.assign({}, item)
        if (item.stopPointType === 'origin') {
          item.arrival_volume = fuelPlanRoute.fuelPlanResult.initial_volume
        } else if (item.stopPointType === 'target') {
          item.arrival_volume = fuelPlanRoute.fuelPlanResult.final_arrival_volume
        }
        return item
      })
      const fuelWaypoints = fuelPlanRoute.fuelPlanResult.poi_list
      fuelWaypoints.forEach(fuelWP => {
        const index = calculateInsertPointIndex(waypoints, fuelWP)
        waypoints.splice(index, 0, fuelWP);
      })
      waypoints = Service.getWaypointList(waypoints, fuelPlanRoute.waypointList)
      info = {
        routeType: 'fuelSuccessful',
        fuelPlanWaypoints: waypoints,
        fuelPlanResult: {
          ...fuelPlan,
          code: 200
        }
      }
    }
    return Promise.resolve(info)
  }).catch(() => {
    return Promise.resolve({
      routeType: 'fuelError'
    })
  })
}